export default __webpack_public_path__ + "static/03_topology-d845a5e28d7d71b83db65a2888b3a99f.png";